import React from "react";
function Intro() {
  return (
    <section className="page-banner" style={{ paddingBottom: "50px" }}>
      <div className="container">
        <div className="page-content-wrapper">
          <div className="page-badge">CSRD</div>
          <h1 className="page-title">CSRD Reporting Made Simple.</h1>
          <h1 className="page-title">
            Stay Compliant with Confidence with Updapt AI Powered CSRD Reporting Software
          </h1>
          <p className="page-description" style={{ paddingTop: "15px" }}>
            Updapt simplifies this process—bringing automation, AI, and XBRL compliance into one
            seamless platform.
          </p>
          <p className="page-description" style={{ paddingTop: "15px" }}>
            Updapt’s CSRD Compliance Solution is designed to simplify sustainability reporting
            through AI-powered automation, seamless data integration, and regulatory compliance
            support, reducing the burden of manual data entry and complex disclosures.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
